import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=5d9f8334&scoped=true&"
import script from "./MenuButton.vue?vue&type=script&lang=js&"
export * from "./MenuButton.vue?vue&type=script&lang=js&"
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=5d9f8334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f8334",
  null
  
)

export default component.exports